import {
  Divider,
  ExternalCell,
  ExternalRow,
  Icons,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { ScalingPolicyOrderChangeEvent } from 'features/cluster/workload-optimization/types';

import { findReorderedItems } from './_utils/find-reordered-items';
import { DetailsRowContainer, DetailWitTitle } from './DetailsRowContainer';

export const ScalingPolicyOrderChangedEventDetailsRow = ({
  event,
}: {
  event: ScalingPolicyOrderChangeEvent;
}) => {
  const { reorderedCount, moves } = findReorderedItems(
    event.details.previous,
    event.details.current
  );

  const height = 76;

  return (
    <DetailsRowContainer
      event={event}
      titleRowProps={{ height, sx: { alignItems: 'flex-start' }, py: 16 }}
      titleRowContent={
        <ExternalCell startColumn={1} cellProps={{ width: '100%' }}>
          <Stack gap={12} width="100%">
            <DetailWitTitle
              title="Policies impacted:"
              detail={reorderedCount}
              titleVariant="strong"
            />
            <DetailWitTitle
              title="Initiated by:"
              detail={event.initiatedBy?.email}
              titleVariant="strong"
            />
          </Stack>
        </ExternalCell>
      }
    >
      <ExternalRow height={212} sx={{ alignItems: 'flex-start' }}>
        <ExternalCell startColumn={0}></ExternalCell>
        <ExternalCell
          startColumn={1}
          endColumn={-1}
          width="100%"
          cellProps={{ width: '100%' }}
        >
          <Divider sx={{ width: '100%', mb: 16 }} />

          <Stack rowGap={8} gap={16} maxWidth={200}>
            <Stack
              direction="row"
              alignItems="center"
              gap={48}
              justifyContent="space-between"
            >
              <Typography
                variant="L10R"
                color={tokens.theme.fg.structural.secondary}
              >
                policy name
              </Typography>
              <Typography
                variant="L10R"
                color={tokens.theme.fg.structural.secondary}
              >
                Order
              </Typography>
            </Stack>
            {moves.map(({ from, id, name, to }) => (
              <Stack
                key={id}
                direction="row"
                alignItems="center"
                gap={48}
                justifyContent="space-between"
              >
                <Typography variant="P10R">{name}</Typography>
                <Stack direction="row" columnGap={4} justifyContent="end">
                  <Typography variant="P10R">{from}</Typography>
                  <Icons.ArrowRight
                    css={({ palette }) => ({ color: palette.grey[400] })}
                  />
                  <Typography variant="P10R">{to}</Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </ExternalCell>
      </ExternalRow>
    </DetailsRowContainer>
  );
};
